module.exports = __webpack_public_path__ + "img/ajoutStockExemple.834167c8.png";